// Color class
export default class {
  constructor (config) {
    this._path = null
    this.id = null
    this.name = null
    this.pantone = null
    this.hex_code = null
    this.thumbnail = null
    this.recommend_colorfill = false

    this.fromObject(config)
  }

  fromObject (obj) {
    // Required fields
    this.id = obj.id
    this.name = obj.name
    this._path = obj._path

    // Optional fields
    try {
      this.pantone = obj.pantone
    } finally {}

    try {
      this.hex_code = obj.hex_code
    } finally {}

    try {
      this.thumbnail = obj.thumbnail
    } finally {}

    try {
      this.recommend_colorfill = obj.recommend_colorfill
    } finally {}
  }
}
